import React from 'react';

import { StoreContext } from '../../store';
import Button from '../UIkit/Button';
import { ID_SECTION } from '../../store/constants';

import { ReactComponent as Svg1 } from '../../images/main/1.svg';
import { ReactComponent as Svg2 } from '../../images/main/2.svg';
import { ReactComponent as Svg3 } from '../../images/main/3.svg';
import { ReactComponent as Svg4 } from '../../images/main/4.svg';
import { ReactComponent as Svg5 } from '../../images/main/5.svg';
import { ReactComponent as Svg6 } from '../../images/main/6.svg';
import { ReactComponent as Svg7 } from '../../images/main/7.svg';
import { ReactComponent as Svg8 } from '../../images/main/8.svg';
import { ReactComponent as Svg9 } from '../../images/main/9.svg';
import wellWithIcons from '../../images/main/bgmain.webp';
import wellWithIconsMobile from '../../images/main/bgmain_mobile.webp';
import NavigationButton from '../UIkit/NavigationButton';
import { scroller } from 'react-scroll';

import style from './SectionMain.module.css';

const SectionMain = () => {
  const { contactUs } = React.useContext(StoreContext);

  const routeToWitsml = () => {
    scroller.scrollTo(ID_SECTION.WITSML.to, {
      duration: 800,
      smooth: true,
      offset: 0,
    });
  };

  return (
    <article className={style.container} id={ID_SECTION.MAIN.to}>
      <div className={style.leftImg}>
        <picture>
          <source media="(max-width: 768px)" srcSet={wellWithIconsMobile} />
          <img src={wellWithIcons} alt="wellWithIcons" />
        </picture>
        <div className={style.iconsContainer}>
          <Svg1 className={style.icon} />
          <Svg2 className={style.icon} />
          <Svg3 className={style.icon} />
          <Svg4 className={style.icon} />
          <Svg5 className={style.icon} />
          <Svg6 className={style.icon} />
          <Svg7 className={style.icon} />
          <Svg8 className={style.icon} />
          <Svg9 className={style.icon} />
        </div>
      </div>
      <div className={style.rightText}>
        <div className={style.bgName}>INNERICA</div>
        <h1>Цифровая платформа для строительства скважин</h1>
        <NavigationButton
          title="Решение для работы с WITSML"
          color="white"
          as={'button'}
          onClick={routeToWitsml}
          className={style.link}
        />
        <div
          className={style.bottomContainer}
          data-scroll
          data-scroll-class="visible"
          data-scroll-repeat="true"
          id="headerTrigger"
        >
          <Button className={style.detailbtn} onClick={contactUs.open} variant="plain" color="white" round>
            Свяжитесь с нами
          </Button>
        </div>
      </div>
    </article>
  );
};

export default SectionMain;
